export const FINANCIAL_EPSILON = 0.004;

export const dateKey = (value) => {
  if (!value) return null;
  const directMatch = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (directMatch) return `${directMatch[1]}-${directMatch[2]}-${directMatch[3]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
};

export const displayDate = (value) => {
  const key = dateKey(value);
  if (!key) return null;
  const [year, month, day] = key.split('-');
  return `${day}/${month}/${year}`;
};

export const deriveFinancialStatus = ({
  saldo,
  totalPagosAplicados,
  fechaVencimiento,
  today = new Date(),
}) => {
  if (Number(saldo || 0) <= FINANCIAL_EPSILON) return 'Cobrada';
  if (Number(totalPagosAplicados || 0) > FINANCIAL_EPSILON) return 'Parcial';
  const dueDate = dateKey(fechaVencimiento);
  const todayDate = dateKey(today);
  if (dueDate && todayDate && dueDate < todayDate) return 'Vencida';
  return 'Pendiente';
};

export const hasInvalidDueDateOrder = ({ fechaEmision, fechaVencimiento }) => {
  const issueDate = dateKey(fechaEmision);
  const dueDate = dateKey(fechaVencimiento);
  return Boolean(issueDate && dueDate && dueDate < issueDate);
};
